<template>
    <div>
		<div class="color-danger">这里仅展示销售排名前50的演出</div>
		<div class="page-filter-box MT20">
		    <el-row :gutter="20">
				<el-col  :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
				            <el-option label="演出ID" :value="1"></el-option>
				            <el-option label="演出名称" :value="2"></el-option>         
				        </el-select>
				    </el-input>
				</el-col>
		        <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                    
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        :clearable="false"
					        popper-class="el-date-picker_clearable"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
		        </el-col>		        
		        <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column prop="platform" label="销售渠道"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出标题" min-width="150"></el-table-column>
                <el-table-column prop="rank" label="实际收入占比-仅看推送过" min-width="180"></el-table-column>
                <el-table-column prop="amount" label="实际收入"></el-table-column>
                <el-table-column prop="orderNum" label="订单数"></el-table-column>
				<el-table-column prop="totalNum" label="售票数"></el-table-column>
				<el-table-column prop="discounts" label="优惠金额"></el-table-column>                
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>       
    </div>
</template>

<script>
import dayjs from 'dayjs';
const defaultParams = {
	searchType: 1,
	searchValue: '',
    pageNo:1,
    
}
export default {
    components: {},
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				searchType:parseInt(this.$route.query.searchType || 1),
				searchValue: this.$route.query.searchValue || '',
            },
            listLoading: false,
			timeType:1,
			time:[]
           
        }
    },
    created(){
		if( this.$route.query.timeStart ){
			this.time = [this.$route.query.timeStart,this.$route.query.timeEnd]
		}else{
			const date = new Date();
			const month = date.getMonth();
			const day = date.getDate();		
			const start = new Date();
			const end = new Date();			
			start.setMonth(month - 3, day + 1);
			start.setHours(0, 0, 0);			
			end.setHours(23, 59, 59);
			this.time = [dayjs(start).format('YYYY-MM-DD HH:mm:ss'),dayjs(end).format('YYYY-MM-DD HH:mm:ss')]
		}
		
		
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
			const {platform} = this.$route.query;
			const {...params} = this.params;
			
            this.listLoading = true;
            this.$request({
                url: "/sales/platform/activity/proportion",
                method: "POST",
                data: {...params,
					platform,
					timeStart:this.time[0],
					timeEnd:this.time[1]
				}
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.time = [this.$route.query.timeStart,this.$route.query.timeEnd]
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
			
            this.getDataList();
        },
       
    }
}
</script>

<style lang="scss" scoped>

</style>